import * as React from 'react'
import { useInView } from 'react-intersection-observer';
import { ManagerContext } from '../contexts/ManagerContext';
import { OpenAiContext } from '../contexts/OpenAiContext';
import { UiContext } from '../contexts/UiContext';
import AvatarChat from '../components/AvatarStatic/AvatarChat';
import SupportImage from '../image/support_dreams.png';
import KwiatyImage from '../image/kwiaty.png';
import Baner from '../image/baner.png';
import {Box, Grid2 as Grid, Card, Button, Stack, Typography } from '@mui/material'
import { array } from 'zod';
import { styled } from '@mui/material/styles';
import DialogTitle from '@mui/material/DialogTitle';
import ChatContainer from '../components/chat/ChatContainer';
import Grow from '@mui/material/Grow';
import { Instagram } from '@mui/icons-material';

const TitleBar = styled(DialogTitle)(({ theme }) => ({
  background: 'linear-gradient(45deg, #808080, #0e1328)',
  color: '#fff',
  fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
  textAlign: 'center'
}));

const GrowOnView = ({ children }) => {
    const [ visible, setVisible ] = React.useState(false)
    const { ref, inView } = useInView({
      threshold: 0.1, // zmieniaj według potrzeb
    });
    React.useEffect(() => {
        if (inView) {
            setVisible(true)
        }
    }, [inView]);
          
  
    return (
      <Box
        ref={ref}
        sx={{
          transition: 'transform 0.3s ease, opacity 0.3s ease',
          transform: visible ? 'scale(1)' : 'scale(0.5)',
          opacity: visible ? 1 : 0,
        }}
      >
        {children}
      </Box>
    );
};



export default function PayPage() {
    const pageName = 1 //donation_page
    const [ _isInit, _setIsInit ] = React.useState(false);
    const { openBackDrop, closeBackDrop } = React.useContext(UiContext);
    const { sendTask, setCurrentPage, connectionState, isInit} = React.useContext(ManagerContext);
    const { openai, 
        stream, setStream,
        activeRun, setActiveRun } = React.useContext(OpenAiContext);

    const [messages, setMessages] = React.useState([]);
    const [_chat, _setChat] = React.useState({
        assistant_id: 'asst_0td4cNuDeFE9hz2IRW6vZgvQ',
        activeThread: null,
      });

    const lista = [
        {text: 'Donation 5 euro + ', url: 'https://checkout.revolut.com/pay/2af93117-8d1a-4eaa-beb8-68a70ae4125d'},
        {text: 'Donation 10 euro + ', url: 'https://checkout.revolut.com/pay/c08c8006-8ca7-4ac2-9e72-e9810abc9c22'},
        {text: 'Donation 20 euro + ', url: 'https://checkout.revolut.com/pay/23a3dc7a-d49b-441e-b7ad-775612871197'},
        {text: 'Donation 50 euro + ', url: 'https://checkout.revolut.com/pay/b0a7d13a-4c5b-4743-acef-db847b71626f'},
        {text: 'Donation 100 euro + ', url: 'https://checkout.revolut.com/pay/b8c918b0-408e-4e52-8095-0b39c0f7e210'},
        {text: 'Donation 200 euro + ', url: 'https://checkout.revolut.com/pay/1a9c819f-c45c-49d1-ba39-76adf208e289'},
        {text: 'Donation 500 euro + ', url: 'https://checkout.revolut.com/pay/73c23ca6-30b3-4b41-8d2b-71954343ff2f'}, 
        {text: 'Donation ??? euro + ', url: 'https://checkout.revolut.com/pay/3ccd2377-91a3-4a73-9863-18e5dc2eca17'},
    ]



    const handleDonate = () => {    
        console.log('click donate')
        gtag('event', 'click_donate',{
            'event_category': 'finanse',
            'event_label': 'User click on donate',
            'value': 1
        });
    }

    React.useEffect(() => {
        openBackDrop();
      }, []);

    React.useEffect(() =>{
    
            const handleInit = async () => {
                if(messages.length > 0) return;
                openBackDrop();
                setMessages([])
                const thread = await openai.beta.threads.create();
                _setChat(prev =>{
                    const newPrev = {
                        ...prev,
                        activeThread: thread,
                    }
                    console.log('PayPage init newChat', newPrev)
                    return newPrev
                });
                
                const result = await sendTask("get_instruction")
                const _stream = await openai.beta.threads.runs.create(
                    thread.id,
                    { 
                        assistant_id: 'asst_0td4cNuDeFE9hz2IRW6vZgvQ',
                        instructions: JSON.stringify(result.data.instructions),
                        additional_instructions: 'Przechodzimy na stronę donate. Zachęć odbiorcę do wsparcia poprzez wpłaty na rzecz rozwoju portalu komunikacyjnego i informacyjnego Mosaic Guardians. Nasi informatycy robia co w ich mocy aby idea znalazła największe grono odbiorców a przygoda nabrała niesamowitego kształtu oraz rozmachu. Staramy się aby inicjatywa była całkowicie darmowa jednak na tym etapie wasze wsparcie jest niezbędne',
                        // additional_messages: query?[ { role: "user", content: query } ]:null,
                        stream: true,
                        model: "gpt-4o-mini",

                    }
                );
                // const _stream = await openai.beta.threads.createAndRun({
                //     assistant_id: chat.assistant_id,
                //     // instructions: JSON.stringify(result.data.instructions),
                //     model: "gpt-4o-mini",
                //     stream: true,
                //     thread: {
                //         messages: [ { role: "assistant", content: "przywitaj nowego odkrywcę naszej społeczności", metadata: {visible: 'hidden'} } ]
                //     }
                // })
                setStream(_stream)
                
                    

                    
                
                ready()
            };
                
            if ( connectionState === "OPEN" && isInit ){
                try{
                    handleInit();
                }catch(error){
                    console.error(error)
                }  
            }
        }, [connectionState, isInit])

    const ready = () => {
        closeBackDrop();
        _setIsInit(true);
    }

    setCurrentPage(pageName)
    return (
        <Box sx={{ flexGrow: 1, width: {xs:'100%', md:'100%'}, height: 'calc(100dvh - 70px)', mt: 1, justifySelf: 'center', overflowY: 'auto', overflowX: 'hidden' }}>
            <ChatContainer size= 'small'
                messages={messages}
                setMessages={setMessages}
                _chat={_chat}
                _setChat={_setChat}
                activeRun={activeRun}
                setActiveRun={setActiveRun}
            />
            <Grow in={_isInit}>
                <Grid container spacing={1} alignItems='start' justifyContent='center' justifyItems='center' sx={{ paddingTop: '30px', marginLeft: '10%', marginRight: '10%'}}>

                    {lista.map((item, index) => (
                        

                        <Grid key={index} size={{ xs:6, sm:6, md:6, lg:3, xl:3 }}>
                            <GrowOnView>
                            <Card style={{    
                                display: 'flex',
                                justifyContent: 'center',
                                backgroundColor:'hsl(220deg 30% 6% / 50%)',
                                // height: '500px'
                                }}>
                                    <Stack spacing={1} direction='column' alignItems='center' justifyContent='center'>
                                            <img src={SupportImage} style={{
                                                width: '100%',
                                                height: 'auto',
                                                }}/>
                                            {/* <div className="image_container_header" style={{ height: '100dvh',backgroundColor: '#00000042', backgroundBlendMode: 'multiply', backgroundImage: `url(${SupportImage})`, height: '80%'}}></div> */}
                                            <a href={item.url} target="_blank" rel="noopener noreferrer">
                                                <Button variant="contained" size="large" onClick={handleDonate}> 
                                                    {item.text}
                                                </Button>
                                            </a>
                                        {/* <Button variant="contained" size="large" > 
                                            {item.text}
                                        </Button> */}
                                        {/* <div style={{ height: '5px'}} >

                                        </div> */}
                                    </Stack>
                                
                                
                            </Card>
                            </GrowOnView>
                        </Grid>
                    
                        
                    )
                    )}

                </Grid>
            </Grow>
        </Box>
    );
}